import Table from '../../table.js';

namespace('IO.Views.NodeGroups', function (exports) {
  'use strict';

  var Index = Table.extend({
    dom: {
      DATATABLES: 'table.display',
      MASKED_PASSWORD: '.mask-password',
    },

    opts: {
      ajaxSource: 'node_groups.json',
      controller: 'node_groups',
      fixed: false,
      filter: true,
      title: 'Click to edit',
    },

    render: function () {
      this.$(this.dom.MASKED_PASSWORD).maskPassword();
      Table.prototype.render.call(this);
    },
  });

  exports.Index = Index;
});
